import { render, staticRenderFns } from "./vehiles.vue?vue&type=template&id=5cb32240&"
import script from "./vehiles.vue?vue&type=script&lang=js&"
export * from "./vehiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports